import {
  initSetup,
  createPreviewComponents,
  prefetchCustomCSM,
  createPreview,
} from './previewerApi';
import type {
  CreatePreviewComponentsParams,
  CreatePreviewParams,
} from './previewerApi';
import type { MiniSiteManager } from '@wix/document-services-types';

export interface StandalonePreviewerApi {
  createPreviewComponents: (
    params: CreatePreviewComponentsParams,
  ) => Promise<React.ReactElement>;
  createPreview: (params: CreatePreviewParams) => Promise<React.ReactElement>;
  prefetchCustomCSM: (publishedTemplateMetasiteId: string) => Promise<void>;
}

export const createStandalonePreviewerApi = async (
  miniSiteManager: MiniSiteManager,
) => {
  initSetup(miniSiteManager);

  const { ds, createPreviewElements } = miniSiteManager;

  const standalonePreviewerApi = {
    createPreviewComponents: async (params: CreatePreviewComponentsParams) => {
      return createPreviewComponents(ds, createPreviewElements, params);
    },
    createPreview: async (params: CreatePreviewParams) => {
      return createPreview(ds, createPreviewElements, params);
    },
    prefetchCustomCSM: async (publishedTemplateMetasiteId: string) => {
      return prefetchCustomCSM(ds, publishedTemplateMetasiteId);
    },
  };

  return standalonePreviewerApi;
};
